import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { deleteClientNote } from '../../../../store/client'
//@ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
import { actions as DetailsContainerActions } from '../../../DetailsContainer'
import { deleteNoteModalName } from '../../constants'
import { translateLKMessage } from '../../helpers'
import { AppDispatch } from 'src/store/index.d'

const DeleteNoteModal: FC<{ onRefresh: () => void }> = ({ onRefresh }) => {
  const dispatch = useDispatch<AppDispatch>()

  function handleConfirm({ ID, hash, noteId }: { ID: number; hash: string; noteId: number }) {
    dispatch(
      deleteClientNote({
        ID: noteId,
        ClientID: ID,
        HashSum_ClientID_: hash,
      }),
    )
      //@ts-ignore
      .then((response) => {
        if (deleteClientNote.fulfilled.match(response)) {
          dispatch(
            DetailsContainerActions.fetchPage({
              type: 'Client',
              ID,
              hash,
              page: 'notes',
            }),
          )

          onRefresh()
        }
      })
      .catch((error) => {
        dispatch(LKModalActions.openError(translateLKMessage(error.Error.Message || error.Error.Text)))
      })
  }

  return <LKModal.Confirmation name={deleteNoteModalName} onConfirm={handleConfirm} />
}

export const openDeleteNoteModal = (ID: number, hash: string, noteId: number) =>
  LKModalActions.openConfirmation(deleteNoteModalName, {
    message: translateLKMessage('CONFIRM_REMINDER_DELETE'),
    ID,
    hash,
    noteId,
  })

export default DeleteNoteModal
